// extracted by mini-css-extract-plugin
export default {"container":"NT","promoapplied":"OT","tobeapplied":"PT","hr":"QT","teal":"RT","promoappliedcontainer":"ST","error":"TT","input":"UT","errorInput":"VT","promo_x":"WT","promo_info":"XT","promoxcontainer":"YT"};
    if(module.hot) {
      // 1726593107365
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  